import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ig-link-button',
    templateUrl: './link.button.component.html',
    styleUrls: ['./link.button.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LinkButtonComponent {
    @Input() public link: string;
    @Input() public isInternal: boolean = true;
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/link.button/link.button.component.ts